import React from 'react';

const IndicatorBottomSvg = () => {
  return (
    <svg
      width='9'
      height='8'
      viewBox='0 0 9 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.829397 7.35309L4.81059 0.841556L8.82936 7.32997L0.829397 7.35309Z'
        fill='url(#paint0_linear_1_4)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1_4'
          x1='1.82506'
          y1='5.85021'
          x2='7.32503'
          y2='5.83431'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#CC1313' />
          <stop offset='1' stopColor='#CC1313' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IndicatorBottomSvg;
